import React, { useEffect, useMemo, useState } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import ArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useLocation } from "react-router";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  // const scrollToTopPage = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };

  // const scrollToBottom = () => {
  //   window.scrollTo({
  //     bottom: 0,
  //     behavior: "smooth",
  //   });
  // };
  // const [showTopBtn, setShowTopBtn] = useState(false);
  // const [showBottomBtn, setShowBottomBtn] = useState(true);

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     if (window.scrollY > 100) {
  //       setShowTopBtn(true);
  //     } else {
  //       setShowTopBtn(false);
  //     }

  //     if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
  //       setShowBottomBtn(false);
  //     } else {
  //       setShowBottomBtn(true);
  //     }
  //   });
  // }, []);

  // const goToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // };

  // const goToBottom = () => {
  //   window.scrollTo({
  //     top: document.body.scrollHeight,
  //     behavior: "smooth",
  //   });
  // };

  return (
    <div className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`} id="kt_footer">
      {/* <div className="scroll-buttons" style={{ position: "fixed", bottom: "30px", zIndex: "10000000", left: "10px" }}>
        {showTopBtn && (
          <button className="scroll-btn top-btn" onClick={goToTop}>
            1
          </button>
        )}
        {showBottomBtn && (
          <button className="scroll-btn bottom-btn" onClick={goToBottom}>
            2
          </button>
        )}
      </div> */}
      {/* <div className="scroll-buttons " style={{ position: "fixed", bottom: "30px", zIndex: "10000000", left: "10px" }}>
        <div>
          <button onClick={goToTop} className="btn btn-primary mb-1 btn-sm px-2" aria-label="Scroll to top">
            <ArrowUpIcon />
          </button>
        </div>

        <div>
          <button onClick={goToBottom} className="btn btn-primary btn-sm  px-2" aria-label="Scroll to bottom">
            <ArrowDownIcon />
          </button>
        </div>
      </div> */}
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">{today.toString()}</span> &copy;{" "}
          <a href="" target="_blank" rel="noopener noreferrer" className="text-dark-75 text-hover-primary">
            Tafrihan
          </a>
        </div>
        {/* <div className="nav nav-dark order-1 order-md-2">
          <a
            href="http://keenthemes.com/metronic"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pr-3 pl-0"
          >
            About
          </a>
          <a
            href="http://keenthemes.com/metronic"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link px-3"
          >
            Team
          </a>
          <a
            href="http://keenthemes.com/metronic"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pl-3 pr-0"
          >
            Contact
          </a>
        </div> */}
      </div>
    </div>
  );
}
